import textServices from 'services/text-services'
import { PIT_STOPS } from '../constants'
import F1Picture from './F1Picture'

// Calendar (Figma 5595:12132): one divider-separated row per pit stop with
// the star bullet, fed from the PIT_STOPS campaign constants.
const CalendarSection = () => {
  return (
    <div className="pitstops__calendar">
      <h2 className="pitstops__calendar-title">
        {textServices.findByText('pitstops/calendar/title', 'Calendario')}
      </h2>
      <ul className="pitstops__calendar-list">
        {PIT_STOPS.map(({ key, order, dateLabel }) => (
          <li key={key} className="pitstops__calendar-row">
            <span className="pitstops__calendar-label">
              <F1Picture name="calendario-estrella" className="pitstops__calendar-star" />
              {textServices.findByText('pitstops/calendar/rowLabel', 'Pit Stop')} {order}
            </span>
            <span className="pitstops__calendar-date">{dateLabel}</span>
          </li>
        ))}
      </ul>
      <p className="pitstops__calendar-legend">
        {textServices.findByText(
          'pitstops/calendar/legend',
          'TODAS LAS ACTIVACIONES SE ANUNCIARÁN POR NUESTRO CANAL DE WHATSAPP'
        )}
      </p>
    </div>
  )
}

export default CalendarSection
